export function addQueryParams(
  base: string | undefined,
  params: Record<string, string | boolean | number | null | undefined>
) {
  const [basePath, ...baseSearch] = (base ?? '').split('?');
  const prevSearch = new URLSearchParams(baseSearch.join('?'));

  const qs = new URLSearchParams(
    Object.fromEntries([
      ...prevSearch.entries(),
      ...Object.entries(params)
        .map(([k, v]) => (v != null ? [k, v?.toString()] : null))
        .filter((i): i is [string, string] => i != null),
    ])
  );

  if (qs.toString() === '') {
    return basePath;
  }
  return `${basePath}?${qs.toString()}`;
}
